var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-areaCode-select" },
    [
      _c("Select", {
        attrs: {
          label: _vm.label,
          options: _vm.areaCodeOption,
          value: _vm.value,
          startVerific: _vm.startVerific,
          placeholder: _vm.placeholder,
          isError: _vm.isError,
          isVerific: _vm.isVerific,
          errmsg: _vm.errmsg
        },
        on: { change: _vm.handleChange, blur: _vm.handleBlur }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }